import React from "react";
import PropTypes from "prop-types";

export const renderField = ({ input, label, type, style, meta: { touched, error, warning } }) => (
  <div>
    <input {...input} type={type} style={style} />

    {touched &&
      ((error && <div className="field__error">{error}</div>) ||
        (warning && <div className="field__error">{warning}</div>))}
  </div>
);

renderField.propTypes = {
  input: PropTypes.object,
  label: PropTypes.string,
  type: PropTypes.string,
  style: PropTypes.object,
  meta: PropTypes.object,
};

export const renderTextAreaField = ({ input, label, rows, cols, style, meta: { touched, error, warning } }) => (
  <div>
     {label && <label>{label}</label>}
    <textarea {...input} style={style} rows={rows} cols={cols}/>

    {touched &&
      ((error && <div className="field__error">{error}</div>) ||
        (warning && <div className="field__error">{warning}</div>))}
  </div>
);

renderTextAreaField.propTypes = {
  input: PropTypes.object,
  label: PropTypes.string,
  rows: PropTypes.string,
  cols: PropTypes.string,
  style: PropTypes.object,
  meta: PropTypes.object,
};


export const renderFieldWithLabel = ({
  input,
  label,
  type,
  style,
  meta: { touched, error, warning },
}) => (
  <div style={{ display: "flex", alignItems: "center", padding: 5 }}>
    {label && <label>{label}</label>}
    <div style={{ flexGrow: 1 }}>
      <input {...input} type={type} style={{ ...style, width: "100%" }} />

      {touched &&
        ((error && <div className="field__error">{error}</div>) ||
          (warning && <div className="field__error">{warning}</div>))}
    </div>
  </div>
);

renderFieldWithLabel.propTypes = {
  input: PropTypes.object,
  label: PropTypes.string,
  type: PropTypes.string,
  style: PropTypes.object,
  meta: PropTypes.object,
};

export const renderMonthYearPicker = ({
  input,
  label,
  style,
  meta: { touched, error, warning },
}) => (
  <div style={{ display: "flex", alignItems: "center", padding: 5 }}>
    {label && <label>{label}</label>}
    <div style={{ flexGrow: 1 }}>
      <input
        {...input}
        type="month"
        style={{ ...style, width: "100%" }}
        onChange={(event) => {
          // Pass the value to the Redux Form's input onChange method
          input.onChange(event.target.value);
        }}
      />

      {touched &&
        ((error && <div className="field__error">{error}</div>) ||
          (warning && <div className="field__error">{warning}</div>))}
    </div>
  </div>
);

renderMonthYearPicker.propTypes = {
  input: PropTypes.object,
  label: PropTypes.string,
  style: PropTypes.object,
  meta: PropTypes.object,
};


// WEBPACK FOOTER //
// ./components/employee/hdf-forms/Axa/components.js